<ng-container *ngIf="isGroupedAttributesList; else listOnlyAttributeType">
    <div style="display: flex;">
        <ion-item lines="none">
            <ion-button mode="ios" fill="clear" size="medium" color="primary"
                        (click)="checkAllAttributes()">
                {{ 'reports.selectAll' | translate }}
            </ion-button>
        </ion-item>
        <ion-item lines="none">
            <ion-button mode="ios" fill="clear" size="medium" color="danger"
                        (click)="unCheckAllAttributes()">
                {{ 'reports.cleanSelection' | translate }}
            </ion-button>
        </ion-item>
    </div>
    <ion-searchbar [debounce]="1000" (ionInput)="searchAttributes($event)"></ion-searchbar>
    <div class="grouped-attribute-list">
        <div class="attributes" *ngFor="let attributeType of groupedAttributesDisplayed; let groupIndex = index">
            <div>
                <a (click)="listAttributes(groupIndex)">
                    <span *ngIf="!attributeType.listAttributes" class="bp-arrow-right-fill"></span>
                    <span *ngIf="attributeType.listAttributes" class="bp-arrow-bottom-fill"></span>
                </a>
                <a (click)="changeChecked(attributeType.checked, groupIndex)">
                    <div [ngClass]="attributeType.checked ? 'circle-icon' : (attributeType.partialChecked ? 'semi-checked-circle-icon' : 'checked-circle-icon')">
                        <ion-label></ion-label>
                    </div>
                </a>
                <ion-label>{{ attributeType.type }}</ion-label>
            </div>
            <ng-container *ngIf="attributeType.listAttributes">
                <div class="sub-attributes">
                    <div *ngFor="let attribute of attributeType.attributes; let attributeIndex = index">
                        <a (click)="changeChecked(attribute.checked, groupIndex, attributeIndex)">
                            <div [ngClass]="attribute.checked ? 'circle-icon' : 'checked-circle-icon'">
                                <ion-label></ion-label>
                            </div>
                        </a>
                        <ion-label>{{ attribute.name }}</ion-label>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #listOnlyAttributeType>
    <div class="fields">
        <div>
            <h2>{{ 'reports.optionalFields' | translate }}</h2>
            <p>{{ 'reports.optionalFieldsDescription' | translate }}</p>
        </div>
        <div class="buttons">
            <ion-button mode="ios" fill="clear" size="small" color="danger"
                        (click)="toggleSelectedField(false)">
                {{ 'reports.clearOptionalFields' | translate }}
            </ion-button>
            <ion-button mode="ios" fill="clear" size="small" color="primary"
                        (click)="toggleSelectedField(true)">
                {{ 'reports.selectAllOptionalFields' | translate }}
            </ion-button>
        </div>
    </div>

    <ion-list mode="ios" lines="none" *ngIf="showOptionalFields">
        <ion-grid>
            <ion-row>
                <ion-col size="12" size-md="6" *ngFor="let f of fields">
                    <ion-item lines="none" (click)="selectField(f)">
                        <ion-checkbox custom-checkbox
                                      slot="start" mode="ios"
                                      [checked]="f.selected"
                        ></ion-checkbox>
                        <ion-label class="ion-text-wrap">
                            {{ f.displayName }}
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-list>
</ng-template>